import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate } from '@helpers/product-events';

function get(page, pageSize) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/messaging/automations?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/messaging/automations/${id}`, requestOptions).then(handleResponse);
}

function save(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/messaging/automations`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.AutomationCreated));
}

function activate(id) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/messaging/automations/${id}/activate`, requestOptions).then(handleResponse);
}

function pause(id) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/messaging/automations/${id}/pause`, requestOptions).then(handleResponse);
}

function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/messaging/automations/${id}`, requestOptions).then(handleResponse);
}

export const automationsService = {
    get,
    getById,
    save,
    activate,
    pause,
    remove,
};
